import * as React from "react";
import type { SVGProps } from "react";
const SvgKnowledgeManagement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      d="M6.478 29.8C3.442 29.8.96 32.282.96 35.32v3.318c0 3.037 2.483 5.52 5.52 5.52h.038V29.8h-.039ZM32.955 11.735c3.01 0 5.451-2.436 5.451-5.441a5.446 5.446 0 0 0-5.45-5.441 5.446 5.446 0 0 0-5.452 5.44 5.446 5.446 0 0 0 5.451 5.442Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.955 1.704a4.594 4.594 0 0 0-4.6 4.59 4.594 4.594 0 0 0 4.6 4.59c2.541 0 4.599-2.057 4.599-4.59a4.594 4.594 0 0 0-4.6-4.59Zm-6.303 4.59A6.298 6.298 0 0 1 32.955 0a6.298 6.298 0 0 1 6.302 6.293 6.298 6.298 0 0 1-6.302 6.292 6.298 6.298 0 0 1-6.303-6.292Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M40.82 24.534H25.167c-.818 0-1.548-.555-1.635-1.362-.71-6.357 5.996-8.06 9.675-8.099 7.923.467 9.451 5.023 9.188 8.137-.068.789-.788 1.314-1.577 1.314v.01Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m33.199 14.222.059.001c4.12.243 6.732 1.562 8.264 3.377 1.523 1.803 1.867 3.965 1.723 5.682v.002c-.11 1.265-1.193 2.02-2.267 2.087a.858.858 0 0 1-.159.015H25.168c-1.174 0-2.34-.808-2.482-2.121-.195-1.749.117-3.227.797-4.449.675-1.214 1.683-2.123 2.803-2.793 2.22-1.328 4.98-1.78 6.913-1.801Zm7.49 9.46a.86.86 0 0 1 .13-.009c.453 0 .706-.286.728-.535.118-1.398-.17-3.07-1.326-4.44-1.144-1.354-3.25-2.544-7.034-2.773-1.745.023-4.16.443-6.026 1.56-.928.555-1.693 1.265-2.19 2.16-.492.885-.752 2.003-.592 3.432v.003c.033.302.327.603.789.603H40.69ZM6.372 30.652a4.681 4.681 0 0 0-4.666 4.667v3.32a4.68 4.68 0 0 0 4.666 4.666H57.63a.852.852 0 0 1 0 1.704H6.372c-3.507 0-6.371-2.863-6.371-6.37v-3.32c0-3.508 2.864-6.371 6.371-6.371H57.63a.852.852 0 1 1 0 1.704H6.372Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M6.44 28.948c.47 0 .853.381.853.852v14.211a.852.852 0 0 1-1.705 0v-14.21c0-.472.381-.853.852-.853Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M57.513 48.78c3.036 0 5.519 2.483 5.519 5.52v3.319c0 3.037-2.483 5.519-5.52 5.519h-.038V48.78h.039Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M5.52 48.79c0-.47.382-.852.852-.852H57.63c3.507 0 6.37 2.864 6.37 6.371v3.32c0 3.507-2.863 6.37-6.37 6.37H6.372a.852.852 0 1 1 0-1.704H57.63c2.567 0 4.667-2.1 4.667-4.667V54.31c0-2.566-2.1-4.667-4.667-4.667H6.372a.852.852 0 0 1-.851-.852Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M57.552 47.938c.47 0 .852.382.852.852v14.201a.852.852 0 1 1-1.704 0v-14.2c0-.471.381-.852.852-.852ZM9.422 34.443c0-.47.382-.852.853-.852h43.937a.852.852 0 0 1 0 1.704H10.275a.852.852 0 0 1-.853-.852ZM9.422 39.28c0-.47.382-.852.853-.852h43.937a.852.852 0 0 1 0 1.705H10.275a.852.852 0 0 1-.853-.852ZM9.423 53.589c0-.47.382-.852.852-.852h43.937a.852.852 0 0 1 0 1.704H10.275a.852.852 0 0 1-.852-.852ZM9.423 58.426c0-.47.382-.851.852-.851h43.937a.852.852 0 0 1 0 1.703H10.275a.852.852 0 0 1-.852-.852Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgKnowledgeManagement;
